import { TTP_API_URL } from "Config";

export const getTemporaryAnnexeFileLink = (id, filePath, token) => {
  let url = `${TTP_API_URL}/data/annexe/file?access_token=${token}&id=${id}&filePath=${encodeURIComponent(
    filePath
  )}`;

  return url;
};

export const findCompatibleYear = (filename, elements) => {
  let choosen = elements[0];
  elements.forEach(element => {
    if (filename.includes(element)) {
      choosen = element;
    }
  });

  return choosen;
};

export const findCompatibleCategory = (filename, elements, lng) => {
  let maxCount = 0;
  let position = 0;
  elements.forEach((element, index) => {
    let count = 0;
    filename
      .substring(0, filename.length - 4)
      .split(" ")
      .forEach(key => {
        if (element.label[lng].includes(key)) {
          count++;
        }
      });
    position = count > maxCount ? index : position;
    maxCount = count > maxCount ? count : maxCount;
  });

  return elements[position];
};



// WEBPACK FOOTER //
// ./src/utils/annexe.js